/* LMM Warenkorb-Notiz — EIN gemeinsames Feld „Ihre Bestellnummer / Bemerkungen".
   ==========================================================================
   Ersetzt die frühere Zwei-Feld-Lösung (separates Kundenbestellnummer-Feld +
   Horizon-Standardnotiz). Gespeichert wird ausschliesslich die native Shopify-
   Bestellnotiz `cart.note` über /cart/update.js — sie steht danach als normale
   Bestellnotiz in der Shopify-Bestellung (order.note).

   Diese Datei ist die EINZIGE Speicherlogik für beide Warenkorboberflächen:
     - Cart Drawer      (sections/lmm-cart-drawer.liquid)
     - Warenkorbseite   (snippets/cart-summary.liquid)
   Beide rendern dasselbe Markup aus snippets/lmm-cart-note-field.liquid und
   werden hier über delegierte document-Listener bedient. Dadurch gibt es keine
   zweite Implementierung und keine zwei divergierenden Werte.

   Kernpunkte:
     - Debounce 700 ms beim Tippen, sofortiger Flush bei Blur, „Zur Kasse",
       „Warenkorb bearbeiten" und Drawer-Schliessen.
     - Enter erzeugt einen Zeilenumbruch (mehrzeiliges Feld) und löst KEINE
       Navigation aus — es gibt bewusst keinen keydown-Handler auf dem Feld.
     - Genau ein Request gleichzeitig; ein neuerer Wert überholt einen älteren,
       ältere Antworten können neuere Eingaben nicht überschreiben.
     - Nach jedem erfolgreichen Update ist der vom Server zurückgegebene Cart
       State kanonisch (cart.note), alle DOM-Instanzen werden darauf gesetzt.
     - Ein noch nicht initialisiertes oder frisch gerendertes leeres Feld
       löscht niemals eine vorhandene Notiz: gespeichert wird nur, was der
       Kunde selbst eingegeben hat.
     - Kein leerer catch-Block; Fehler werden sichtbar gemeldet und geloggt.
   ========================================================================== */
(function () {
  if (window.__lmmCartNoteInit) return;
  window.__lmmCartNoteInit = true;

  var SEL = '[data-lmm-note]';
  var BOX = '[data-lmm-note-box]';
  var MAX = 1000;
  var DEBOUNCE = 700;
  var COUNT_FROM = 900; // Zeichenzähler erst kurz vor dem Limit einblenden
  var ERR_TEXT = 'Ihre Eingabe konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.';
  // Auslöser, die den Warenkorb verlassen und deshalb einen offenen Wert
  // vorher zuverlässig speichern müssen.
  var GO_SEL = '.lmm-cd__checkout, .lmm-cd__edit, #checkout, .lmm-cart-edit';

  var saved = null;      // zuletzt vom Server bestätigter Wert; null = noch nicht initialisiert
  var clientSavedNote = false; // true, sobald in dieser Sitzung mindestens ein Schreibvorgang vom Server bestätigt wurde
  var inFlightValue = null; // Wert des aktuell laufenden Requests (während busy === true)
  var pending = null;    // letzte Eingabe des Kunden; null = Kunde hat nichts eingegeben
  var queued = null;     // nächster zu sendender Wert; null = nichts offen
  var busy = false;      // ein Request ist unterwegs
  var lastOk = true;     // Ergebnis des zuletzt tatsächlich gesendeten Requests
  var timer = null;      // laufender Debounce
  var waiters = [];      // Promise-Resolver, die auf „Warteschlange leer" warten
  var lastEdited = null; // zuletzt vom Kunden benutzte Instanz des Feldes

  function rootUrl() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r;
  }

  function warn(msg, error) {
    if (window.console && window.console.warn) window.console.warn('[lmm-cart-note] ' + msg, error);
  }

  function fields() {
    return Array.prototype.slice.call(document.querySelectorAll(SEL));
  }

  // Zeilenumbrüche bleiben erhalten (mehrzeiliges Feld); nur führende und
  // abschliessende Leerräume fallen weg. Harte Kappung auf MAX Zeichen.
  function norm(v) {
    return String(v == null ? '' : v).replace(/\r\n/g, '\n').replace(/^\s+|\s+$/g, '').slice(0, MAX);
  }

  function boxOf(el) {
    return el && el.closest ? el.closest(BOX) : null;
  }

  // Rückmeldung: 'ok' | 'err' | null. Nie nur über Farbe — immer Zeichen + Text.
  function setMsg(kind, text) {
    var els = fields();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var box = boxOf(el);
      if (!box) continue;
      var ok = box.querySelector('[data-lmm-note-ok]');
      var err = box.querySelector('[data-lmm-note-err]');
      box.classList.toggle('lmm-note--invalid', kind === 'err');
      if (ok) ok.hidden = kind !== 'ok';
      if (err) {
        err.hidden = kind !== 'err';
        if (kind === 'err') err.textContent = text || ERR_TEXT;
      }
      if (kind === 'err') el.setAttribute('aria-invalid', 'true');
      else el.removeAttribute('aria-invalid');
    }
  }

  // Höhe an den Inhalt anpassen: startet zweizeilig, wächst bis zur in CSS
  // gesetzten max-height (~6 Zeilen), danach scrollt das Feld intern.
  function grow(el) {
    if (!el || !el.style) return;
    var max = parseFloat(window.getComputedStyle(el).maxHeight);
    if (!(max > 0)) max = 156;
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, max) + 'px';
  }

  function count(el) {
    var box = boxOf(el);
    if (!box) return;
    var out = box.querySelector('[data-lmm-note-count]');
    if (!out) return;
    var len = String(el.value == null ? '' : el.value).length;
    if (len >= COUNT_FROM) {
      out.hidden = false;
      out.textContent = len + ' / ' + MAX + ' Zeichen';
    } else {
      out.hidden = true;
      out.textContent = '';
    }
  }

  // Wert in alle sichtbaren Instanzen schreiben — das gerade fokussierte Feld
  // bleibt unangetastet, damit Tippen nie unterbrochen wird.
  function writeAll(value) {
    var els = fields();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el !== document.activeElement && el.value !== value) el.value = value;
      el.defaultValue = value; // serverseitiger Stand für spätere Re-Renders
      grow(el);
      count(el);
    }
  }

  // Sofortiger Abgleich beim Tippen: Drawer und Warenkorbseite können
  // gleichzeitig im DOM liegen. Ohne diesen Spiegel zeigten sie zwischenzeitlich
  // zwei verschiedene Werte für dieselbe Bestellnotiz — und ein späterer Flush
  // hätte den Wert aus der falschen Instanz gelesen.
  function mirror(value) {
    var els = fields();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el !== document.activeElement && el.value !== value) el.value = value;
    }
  }

  // Maßgeblich ist das Feld, in dem der Kunde gerade schreibt; sonst das
  // zuletzt benutzte. Nie blind das erste Feld im DOM — das kann eine noch
  // nicht abgeglichene Instanz sein.
  function activeField() {
    var els = fields();
    for (var i = 0; i < els.length; i++) if (els[i] === document.activeElement) return els[i];
    for (var j = 0; j < els.length; j++) if (els[j] === lastEdited) return els[j];
    return els.length ? els[0] : null;
  }

  function currentValue() {
    var el = activeField();
    return el ? norm(el.value) : pending;
  }

  // Serverseitig gerenderter Ausgangswert (textarea-Inhalt aus {{ cart.note }}).
  function serverValue() {
    var els = fields();
    return els.length ? norm(els[0].defaultValue) : '';
  }

  function ensureInitialised() {
    if (saved === null && fields().length) saved = serverValue();
  }

  function settleWaiters() {
    if (busy || queued !== null) return;
    var list = waiters;
    waiters = [];
    for (var i = 0; i < list.length; i++) list[i](lastOk);
  }

  function post(value) {
    return fetch(rootUrl() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value }),
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/update.js antwortete mit HTTP ' + r.status);
      return r.json();
    });
  }

  // Genau ein Request gleichzeitig. Kommt währenddessen ein neuerer Wert dazu,
  // ersetzt er den wartenden — dadurch kann keine ältere Antwort eine neuere
  // Eingabe überschreiben und der zuletzt eingegebene Wert gewinnt.
  function pump() {
    if (busy) return;
    if (queued === null) { settleWaiters(); return; }
    var value = queued;
    queued = null;
    if (value === saved) {
      if (pending !== null && pending === value) pending = null;
      lastOk = true;
      settleWaiters();
      return;
    }
    busy = true;
    inFlightValue = value;
    post(value)
      .then(function (cart) {
        // Kanonisch ist der vom Server zurückgegebene Warenkorb.
        var serverNote = norm(cart && cart.note);
        saved = serverNote;
        clientSavedNote = true;
        if (queued === null) {
          if (pending !== null && pending === value) pending = null;
          lastOk = true;
          writeAll(serverNote);
          setMsg(serverNote ? 'ok' : null);
        }
      })
      .catch(function (error) {
        lastOk = false;
        setMsg('err', ERR_TEXT);
        warn('Speichern der Bestellnotiz fehlgeschlagen.', error);
      })
      .then(function () {
        busy = false;
        inFlightValue = null;
        if (queued !== null) pump();
        else settleWaiters();
      });
  }

  function enqueue(value) {
    queued = value;
    pump();
  }

  // Speichert einen offenen Wert sofort. Liefert Promise<boolean> — true, wenn
  // nichts offen war oder der letzte Request erfolgreich beendet wurde.
  function flushNow() {
    if (timer) { window.clearTimeout(timer); timer = null; }
    if (!fields().length) return Promise.resolve(true);
    ensureInitialised();
    var value = currentValue();
    pending = value;
    var effectiveTarget = busy ? inFlightValue : saved;
    if (value !== effectiveTarget || (queued !== null && value !== queued)) {
      enqueue(value);
    }
    if (!busy && queued === null) return Promise.resolve(lastOk);
    return new Promise(function (resolve) { waiters.push(resolve); });
  }

  // Nach jedem Re-Render: Werte neu aus dem aktuellen Cart State übernehmen.
  // Eine noch nicht gespeicherte Eingabe hat Vorrang und wird erneut gesichert,
  // damit sie durch ein Section-Rendering nicht verloren geht.
  function adopt() {
    var els = fields();
    if (!els.length) return;
    if (pending !== null && pending !== saved) {
      writeAll(pending);
      enqueue(pending);
      return;
    }
    if (!clientSavedNote || saved === null) {
      saved = serverValue();
    }
    pending = null;
    writeAll(saved);
  }

  // Nach einem Fehler den Fokus in das Feld zurückgeben, das der Kunde
  // tatsächlich benutzt hat.
  function focusField() {
    var el = activeField();
    if (!el || !el.focus) return;
    el.focus();
  }

  // --- Tippen: debounced speichern -----------------------------------------
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches(SEL)) return;
    ensureInitialised();
    setMsg(null);
    lastEdited = t;
    // maxlength begrenzt Tippen und Einfügen, einen programmatisch oder
    // serverseitig längeren Wert aber nicht. Gespeichert wird ohnehin nur bis
    // MAX — deshalb hier sofort angleichen, damit angezeigter und gespeicherter
    // Text nie auseinanderlaufen (im Canary gemessen: Feld 1.200, gespeichert 1.000).
    if (String(t.value).length > MAX) t.value = String(t.value).slice(0, MAX);
    pending = norm(t.value);
    mirror(t.value); // beide Oberflächen zeigen sofort denselben Text
    grow(t);
    count(t);
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () { timer = null; flushNow(); }, DEBOUNCE);
  });

  // --- Feld verlassen: sofort speichern ------------------------------------
  // Deckt auch den Wechsel Drawer <-> Warenkorbseite ab, weil jeder Klick auf
  // einen Link zuerst den Fokus aus dem Textfeld nimmt.
  document.addEventListener('focusout', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches(SEL)) return;
    flushNow();
  });

  // Bewusst KEIN keydown-Handler auf dem Feld: Enter muss in einem
  // mehrzeiligen Textfeld einen Zeilenumbruch erzeugen und darf weder
  // speichern-mit-Navigation noch ein Formular abschicken.

  // --- Verlassen des Warenkorbs: erst speichern, dann weiter ---------------
  document.addEventListener('click', function (e) {
    var go = e.target && e.target.closest ? e.target.closest(GO_SEL) : null;
    if (!go) return;
    // Zweiter Durchlauf nach erfolgreichem Flush: normal weiterlaufen lassen.
    if (go.getAttribute('data-lmm-note-go') === '1') {
      go.removeAttribute('data-lmm-note-go');
      return;
    }
    if (!fields().length) return;
    ensureInitialised();
    var value = currentValue();
    var offen = value !== saved || busy || queued !== null || timer !== null;
    if (!offen) return;
    e.preventDefault();
    e.stopPropagation();
    flushNow().then(function (ok) {
      if (!ok) {
        // Speichern (auch Löschen einer bestehenden Notiz) fehlgeschlagen:
        // keine stille Weiterleitung. Fehler steht am Feld.
        focusField();
        return;
      }
      go.setAttribute('data-lmm-note-go', '1');
      go.click();
    });
  }, true);

  // --- Drawer schliessen: offenen Wert sichern ------------------------------
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-lmm-cd-close]')) flushNow();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (document.querySelector('[data-lmm-cd].is-open')) flushNow();
  }, true);

  // --- Seitenwechsel: verlässliche Absicherung ohne beforeunload-Hack -------
  // sendBeacon wird vom Browser auch nach dem Entladen noch zugestellt.
  function beaconFlush() {
    if (!fields().length || saved === null) return;
    var value = currentValue();
    if (value === saved) return;
    if (!window.navigator || !window.navigator.sendBeacon) return;
    try {
      var blob = new Blob([JSON.stringify({ note: value })], { type: 'application/json' });
      // sendBeacon reiht den Request nur in die Browser-Queue ein; `saved` darf
      // erst durch eine bestätigte Serverantwort aktualisiert werden.
      window.navigator.sendBeacon(rootUrl() + 'cart/update.js', blob);
    } catch (error) {
      warn('Bestellnotiz konnte beim Seitenwechsel nicht gesendet werden.', error);
    }
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') beaconFlush();
  });
  window.addEventListener('pagehide', beaconFlush);

  // --- Re-Render beider Oberflächen ----------------------------------------
  // lmm:cart-rendered  -> eigener Drawer (Section Rendering API)
  // cart:update        -> Horizon-Warenkorbseite (morphSection)
  document.addEventListener('lmm:cart-rendered', function () { adopt(); });
  document.addEventListener('cart:update', function () {
    adopt();
    window.setTimeout(adopt, 60); // nach dem Morphen erneut angleichen
  });

  window.__lmmCartNoteFlush = function () {
    if (!fields().length) return Promise.resolve(true);
    ensureInitialised();
    var value = currentValue();
    return flushNow().then(function (ok) {
      if (!ok) {
        focusField();
        return false;
      }
      return true;
    });
  };

  function init() {
    if (!fields().length) return;
    ensureInitialised();
    writeAll(saved === null ? '' : saved);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
